import cn from 'classnames';
import React from 'react';

import styles from './styles.module.scss';

export enum BorderTypeEnum {
  NOT_ACTIVE,
  SELECTED,
  DISABLED,
}

export const Border: React.FC<{
  type?: BorderTypeEnum;
  children: JSX.Element;
  className?: string;
  classNameSelected?: string;
  transparent?: boolean;
  border?: boolean;
  onClick?: () => void;
}> = ({
  type = BorderTypeEnum.NOT_ACTIVE,
  children,
  className,
  transparent,
  border,
  classNameSelected = '',
  onClick,
}) => {
  return (
    <div
      className={cn(
        styles.container,
        {
          [styles.transparent]: transparent,
          [styles.current]: border,
          [styles.selected]: type === BorderTypeEnum.SELECTED,
          [classNameSelected || '']: type === BorderTypeEnum.SELECTED,
          [styles.notActive]: type === BorderTypeEnum.NOT_ACTIVE,
          [styles.disabled]: type === BorderTypeEnum.DISABLED,
        },
        className,
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
